var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _vm.flags.isFetching
      ? _c(
          "div",
          {
            staticClass:
              "async-loader-screen -helper--flex align-center justify-center"
          },
          [
            _c(
              "div",
              { staticClass: "lotti-wrapper" },
              [
                _c("lottie-player", {
                  attrs: {
                    autoplay: "",
                    loop: "",
                    mode: "normal",
                    src:
                      "https://lili-mobile-images.s3.amazonaws.com/onboarding/lotti/logo_animation.json"
                  }
                })
              ],
              1
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "welcome-wrapper" },
      [
        _vm.isMobile
          ? _c("TopProgressBar", { attrs: { isBackShown: false } })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "welcome-partner-form-view" },
          [
            _c(
              "div",
              { staticClass: "ob-step-container" },
              [
                _c("h2", { staticClass: "title" }, [
                  _vm._v("Your personal details")
                ]),
                _vm._v(" "),
                _c(
                  "v-form",
                  {
                    ref: "form",
                    staticClass: "grid",
                    attrs: { id: "v-form" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.submitForm.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("v-text-field", {
                      ref: "firstName",
                      staticClass: "full-first first-name",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "given-name",
                        rules: _vm.firstNameRules,
                        "error-messages": _vm.formFieldsErrors.firstName,
                        id: "firstName"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("firstName")
                        },
                        input: _vm.validateForm
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "input-legend" }, [
                                _vm._v(_vm._s(_vm.$t("intro.firstName")))
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "firstNameMessage" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.customer.firstName,
                        callback: function($$v) {
                          _vm.$set(_vm.customer, "firstName", $$v)
                        },
                        expression: "customer.firstName"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      ref: "lastName",
                      staticClass: "full-second",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "family-name",
                        rules: _vm.lastNameRules,
                        "error-messages": _vm.formFieldsErrors.lastName,
                        id: "lastName"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("lastName")
                        },
                        input: _vm.validateForm
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "input-legend" }, [
                                _vm._v(_vm._s(_vm.$t("intro.lastName")))
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "lastNameMessage" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.customer.lastName,
                        callback: function($$v) {
                          _vm.$set(_vm.customer, "lastName", $$v)
                        },
                        expression: "customer.lastName"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "v-text-field",
                      {
                        ref: "email",
                        staticClass: "full-first",
                        attrs: {
                          dense: "",
                          filled: "",
                          rounded: "",
                          disabled: true,
                          rules: _vm.inputEmailRules,
                          "error-messages":
                            _vm.formFieldsErrors.email ||
                            _vm.formFieldsErrors.defaultError,
                          type: "email",
                          autocomplete: "username email",
                          "validate-on-blur": "",
                          id: "email"
                        },
                        on: {
                          focus: function($event) {
                            return _vm.clearFieldError("email")
                          },
                          input: _vm.validateForm
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "message",
                            fn: function(ref) {
                              var message = ref.message
                              var key = ref.key
                              return [
                                _c("span", {
                                  key: key,
                                  attrs: { id: "emailMessage" },
                                  domProps: { innerHTML: _vm._s(message) }
                                })
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.customer.email,
                          callback: function($$v) {
                            _vm.$set(_vm.customer, "email", $$v)
                          },
                          expression: "customer.email"
                        }
                      },
                      [
                        _c("template", { slot: "label" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("intro.email")) +
                              "\n            "
                          )
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("v-text-field", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "+1 (###) ###-####",
                          expression: "'+1 (###) ###-####'"
                        }
                      ],
                      ref: "phoneNumber",
                      staticClass: "full-second",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "off",
                        type: "tel",
                        rules: _vm.phoneNumberRules,
                        "error-messages": _vm.phoneErrors,
                        id: "phoneNumber"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("phoneNumber")
                        },
                        input: _vm.validateForm
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "input-legend" }, [
                                _vm._v(_vm._s(_vm.$t("register.label")))
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "phoneMessage" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.formattedPhoneNumber,
                        callback: function($$v) {
                          _vm.formattedPhoneNumber = $$v
                        },
                        expression: "formattedPhoneNumber"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      ref: "line1",
                      staticClass: "full-first",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "address-line1",
                        rules: _vm.line1,
                        "error-messages":
                          _vm.formFieldsErrors.line1 ||
                          _vm.formFieldsErrors.defaultError,
                        id: "line1"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("line1")
                        },
                        input: _vm.validateForm
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "input-legend" }, [
                                _vm._v(_vm._s(_vm.$t("addressDetail.line1")))
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "line1Message" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.customer.line1,
                        callback: function($$v) {
                          _vm.$set(_vm.customer, "line1", $$v)
                        },
                        expression: "customer.line1"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      ref: "line2",
                      staticClass: "half-second line2",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "address-line2",
                        "error-messages": _vm.formFieldsErrors.line2,
                        id: "line2"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("line2")
                        },
                        input: _vm.validateForm
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c(
                                "p",
                                {
                                  staticClass: "input-legend",
                                  staticStyle: { "font-size": "13px" }
                                },
                                [_vm._v(_vm._s(_vm.$t("addressDetail.line2")))]
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "line2Message" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.customer.line2,
                        callback: function($$v) {
                          _vm.$set(_vm.customer, "line2", $$v)
                        },
                        expression: "customer.line2"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "#####",
                          expression: "'#####'"
                        }
                      ],
                      ref: "postaclCode",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "postal-code",
                        rules: _vm.zip,
                        "error-messages": _vm.formFieldsErrors.postalCode,
                        inputmode: "numeric",
                        id: "postalCode"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("postalCode")
                        },
                        input: _vm.validateForm
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "input-legend" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("addressDetail.postalCode")) +
                                    "\n                "
                                )
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "postalCodeMessage" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.customer.postalCode,
                        callback: function($$v) {
                          _vm.$set(_vm.customer, "postalCode", $$v)
                        },
                        expression: "customer.postalCode"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      ref: "city",
                      staticClass: "full-first",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "address-level2",
                        rules: _vm.city,
                        "error-messages": _vm.formFieldsErrors.city,
                        id: "city"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("city")
                        },
                        input: _vm.validateForm
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "input-legend" }, [
                                _vm._v(_vm._s(_vm.$t("addressDetail.city")))
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "cityMessage" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.customer.city,
                        callback: function($$v) {
                          _vm.$set(_vm.customer, "city", $$v)
                        },
                        expression: "customer.city"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "state",
                        staticClass: "state relative full-second",
                        attrs: { id: "primary-user-state" }
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.states,
                            "append-icon": "mdi-chevron-down",
                            label: _vm.$t("addressDetail.state"),
                            "item-text": "title",
                            "item-value": "title",
                            "validate-on-blur": "",
                            rules: _vm.stateRules,
                            filled: "",
                            "menu-props": { contentClass: "selectScroll" }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function(data) {
                                return [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "v-list-item__title",
                                      attrs: { id: data.item.id }
                                    },
                                    [_vm._v(_vm._s(data.item.title))]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.customer.state,
                            callback: function($$v) {
                              _vm.$set(_vm.customer, "state", $$v)
                            },
                            expression: "customer.state"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-text-field", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "###-##-####",
                          expression: "'###-##-####'"
                        }
                      ],
                      ref: "ssn",
                      staticClass: "full-first",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "nope",
                        type: _vm.flags.isSsnShown ? "tel" : "password",
                        "append-icon": _vm.flags.isSsnShown
                          ? _vm.icons.mdiEyeInternal
                          : _vm.icons.mdiEyeOffInternal,
                        rules: _vm.ssn,
                        "error-messages": _vm.formFieldsErrors.ssn,
                        id: "ssn"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("ssn")
                        },
                        input: _vm.validateForm,
                        "click:append": function($event) {
                          _vm.flags.isSsnShown = !_vm.flags.isSsnShown
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "input-legend" }, [
                                _vm._v(_vm._s(_vm.$t("kyc.ssn")))
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "ssnMessage" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.formattedSSN,
                        callback: function($$v) {
                          _vm.formattedSSN = $$v
                        },
                        expression: "formattedSSN"
                      }
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "##/##/####",
                          expression: "'##/##/####'"
                        }
                      ],
                      ref: "birthDate",
                      staticClass: "full-second",
                      attrs: {
                        dense: "",
                        filled: "",
                        rounded: "",
                        "validate-on-blur": "",
                        autocomplete: "nope",
                        type: "tel",
                        placeholder: "MM/DD/YYYY",
                        rules: _vm.birthDate,
                        "error-messages": _vm.formFieldsErrors.birthDate
                          ? _vm.formFieldsErrors.birthDate
                          : _vm.formFieldsErrors.defaultError,
                        id: "birthDate"
                      },
                      on: {
                        focus: function($event) {
                          return _vm.clearFieldError("birthDate")
                        },
                        input: _vm.validateForm
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "input-legend" }, [
                                _vm._v(_vm._s(_vm.$t("kyc.birthDate")))
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "message",
                          fn: function(ref) {
                            var message = ref.message
                            var key = ref.key
                            return [
                              _c("span", {
                                key: key,
                                attrs: { id: "birthDateMessage" },
                                domProps: { innerHTML: _vm._s(message) }
                              })
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.customer.birthDateNotFormatted,
                        callback: function($$v) {
                          _vm.$set(_vm.customer, "birthDateNotFormatted", $$v)
                        },
                        expression: "customer.birthDateNotFormatted"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "horizontal-divider full" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "subtitle full" }, [
                      _vm._v("Create Lili account password")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "password full-first" },
                      [
                        _c(
                          "v-text-field",
                          {
                            ref: "password",
                            attrs: {
                              dense: "",
                              filled: "",
                              rounded: "",
                              "validate-on-blur": "",
                              name: "password",
                              disabled: !!_vm.obData.isPasswordSet,
                              autocomplete: "new-password",
                              type: _vm.flags.isPasswordShown
                                ? "text"
                                : "password",
                              rules: !_vm.isEditMode ? _vm.passwordRules : [],
                              "error-messages":
                                _vm.formFieldsErrors.password ||
                                _vm.formFieldsErrors.defaultError,
                              "append-icon": !!_vm.obData.isPasswordSet
                                ? ""
                                : _vm.flags.isPasswordShown
                                ? _vm.icons.mdiEyeInternal
                                : _vm.icons.mdiEyeOffInternal,
                              id: "password"
                            },
                            on: {
                              focus: function($event) {
                                return _vm.clearFieldError("password")
                              },
                              input: _vm.validateForm,
                              "click:append": function($event) {
                                _vm.flags.isPasswordShown = !_vm.flags
                                  .isPasswordShown
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "message",
                                fn: function(ref) {
                                  var message = ref.message
                                  var key = ref.key
                                  return [
                                    _c("span", {
                                      key: key,
                                      attrs: { id: "passwordMessage" },
                                      domProps: { innerHTML: _vm._s(message) }
                                    })
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.customer.password,
                              callback: function($$v) {
                                _vm.$set(_vm.customer, "password", $$v)
                              },
                              expression: "customer.password"
                            }
                          },
                          [
                            _c("template", { slot: "label" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("intro.password")) +
                                  "\n                "
                              )
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.formFieldsErrors.password,
                              expression: "!formFieldsErrors.password"
                            }
                          ],
                          staticClass: "password-dif-indicator",
                          style: {
                            width: !_vm.customer.password
                              ? "0%"
                              : _vm.score.value,
                            backgroundColor: _vm.score.color
                          },
                          attrs: { id: "passwordProgressBar-error" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("ul", { staticClass: "password-requirements" }, [
                      _c("li", [_vm._v("8 characters or more ")]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v("At least one capital letter and one number")
                      ]),
                      _vm._v(" "),
                      _c("li", [_vm._v("No sequential characters")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "horizontal-divider full" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tnc-btn-wrapper full" },
                      [
                        _c("div", { staticClass: "tnc-content" }, [
                          _c("span", [
                            _vm._v("By clicking CONTINUE you agree to "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://lili.co/legal-documents/lili-terms-of-use",
                                  target: "_blank",
                                  id: "termsOfUse"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleAnchorClick("terms")
                                  }
                                }
                              },
                              [_vm._v("Lili's Terms of Use")]
                            ),
                            _vm._v(",\n                "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://lili.co/legal-documents/lili-privacy-policy",
                                  target: "_blank",
                                  id: "privacyPolicy"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleAnchorClick("privacy")
                                  }
                                }
                              },
                              [_vm._v("Lili's Privacy Policy")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "main-app-cta",
                            class: {
                              "active-cta": _vm.isCtaEnabled
                            },
                            attrs: {
                              elevation: "0",
                              loading: _vm.flags.isLoaderShown,
                              id: "elCta-partner",
                              type: "submit"
                            }
                          },
                          [_vm._v("\n              Continue\n            ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isMobile
              ? _c("div", { staticClass: "welcome-partner-details-view" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2)
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("VueRecaptcha", {
              ref: "recaptcha",
              attrs: {
                id: "recaptcha",
                sitekey: _vm.captchaSiteKey,
                loadRecaptchaScript: true,
                size: "invisible"
              },
              on: { verify: _vm.onVerify, error: _vm.onCaptchaError }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.isMobile ? _c("MobileFooter") : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "welcome-logos-wrapper" }, [
      _c("span", { staticClass: "main-logo-dark-blue" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "partner-details-wrapper" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("Banking designed for your business")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text" }, [
        _vm._v(
          "\n              Lili empowers your business with the banking features you need, while eliminating the hidden fees you don't.\n            "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "list-title" }, [
          _vm._v(
            "Apply for an account and build your business with confidence:"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-title" }, [
          _vm._v("Your Lili account comes with:")
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "text list" }, [
          _c("li", [
            _c("span", [
              _vm._v("\n\n                    3.65%\n                  ")
            ]),
            _vm._v("\n                   Annual Percentage Yield on savings"),
            _c("sup", [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v(" No hidden fees")]),
            _vm._v(
              "\n                 , no overdraft fees, no minimum\n                  deposit or minimum balance required\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [
              _vm._v(
                "\n\n                    Fast money movement\n                  "
              )
            ]),
            _vm._v(
              "\n                  including Standard or Express ACH, wire\n                  transfers\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [
              _vm._v(
                "\n                    Run your business finances\n                  "
              )
            ]),
            _vm._v(
              "\n                  from one place with built-in payments, accounting and tax preparation software\n                "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [
              _vm._v(
                "\n                    Unlock the potential to impact\n                  "
              )
            ]),
            _vm._v("\n                  some of  your D&B business scores"),
            _c("sup", [_vm._v("*")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "partner-footer" }, [
        _c(
          "div",
          { staticClass: "badge -helper--flex space-between align-center" },
          [
            _c("div", { staticClass: "-helper--flex align-center" }, [
              _c("span", { staticClass: "banner-fdic-dark-gray" }),
              _vm._v(" "),
              _c("p", { staticClass: "footer-banner-content" }, [
                _vm._v(
                  "\n                    Lili is a financial technology company, not a bank. Banking services provided by Sunrise Banks, N.A., Member FDIC.\n                  "
                )
              ])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "trust-pilot-dark-gray" })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "disclaimer act-text" }, [
          _vm._v(
            "\n                1 The Annual Percentage Yield (“APY”) for the Lili Savings Account is variable and may change at any time. The disclosed APY is effective as of October 1, 2024. Must have at least $0.01 in savings to earn interest. The APY applies to balances of up to and including $100,000. Any portions of a balance over $100,000 will not earn interest or have a yield. Available to Lili Pro, Lili Smart, and Lili Premium account holders only.\n              "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "disclaimer act-text" }, [
          _vm._v(
            "\n                2 By integrating your Lili Business Bank Account through the D&B Credit Insights banking integration feature, there may be potential for you to positively impact your Delinquency and Failure Scores. Dun & Bradstreet requires a minimum of six months of business banking transaction history to be able to potentially impact these scores.\n              "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer-patriot-act" }, [
          _c("div", { staticClass: "act-title" }, [
            _vm._v("USA PATRIOT Act notice")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "act-text" }, [
            _vm._v(
              "\n                  To help the government fight the funding of terrorism and\n                  money laundering activities, Federal law requires all\n                  financial institutions to obtain, verify, and record\n                  information that identifies each person who opens an\n                  account.\n                "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "act-text" }, [
            _vm._v(
              "\n                  What this means for you: When you open an account, we will\n                  ask for your name, address, date of birth, and other\n                  information that will allow us to identify you. We may also\n                  ask to see your driver's license or other identifying\n                  documents.\n                "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "act-text balance-up" }, [
            _vm._v(
              "\n                  1. BalanceUp is a discretionary overdraft program for debit\n                  card purchases and in paid plans only. Subject to\n                  eligibility, enrollment and continued good standing.\n                  Overdraft limits are discretionary and are $20-$200.\n                "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37213d40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37213d40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PartnerOnboarding/PartnerWelcome.vue
// module id = null
// module chunks = 